export const ADD_PRODUCT_TO_FAVORITES = 'ADD_PRODUCT_TO_FAVORITES';

export const addProductToFavorites = (productId) => {
  return {
    type: ADD_PRODUCT_TO_FAVORITES,
    payload: productId,
  };
};
